import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
    selector: "icon-cell",
    template: `
        @if (!disabled) {
          <mat-icon aria-hidden="false" style="vertical-align: middle" aria-label="Example home icon">done</mat-icon>
        }
        @if (disabled) {
          <mat-icon aria-hidden="false" style="vertical-align: middle" aria-label="Example home icon">cancel</mat-icon>
        }
        
        `,
    styles: [],
    standalone: false
})
export class MatIconComponent implements ICellRendererAngularComp {
    private params: any;

    disabled: boolean = false;

    agInit(params: any): void {
        this.params = params;
        this.disabled = this.params.value;
    }

    refresh(params: any): boolean {
        return false;
    }
}